module.exports = __webpack_public_path__ + "media/images/new/filter_by_elevation-4613e9eeb039a2d5a598a9ad0fbbd311.jpg";